<script>
import ContatoCamposPersonalizadosView from '@/views/app/contato/campos-personalizados.vue';

export default {
  name: 'CadastrosCamposPersonalizadosView',
  components: { ContatoCamposPersonalizadosView },
};
</script>

<template>
  <ContatoCamposPersonalizadosView />
</template>
